import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

interface Vars {
  inviteId: string;
  groupId: string;
}

/**
 * Owner-only: revoke a pending invite.
 */
export function useRevokeInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ inviteId }: Vars) =>
      api.delete<{ ok: true }>(`/api/groups/invites/${inviteId}`),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({
        queryKey: ['groups', 'invites', vars.groupId],
      });
    },
  });
}
